import React from "react";

export default function Engine({ ignition }) {
	return (
		<>
			<div className="d-flex">
				<div className="me-4">
					<img
						src={
							ignition
								? `${process.env.PUBLIC_URL}/assets/New/LiveTrackingSensors/EnginOnHalf.svg`
								: `${process.env.PUBLIC_URL}/assets/New/LiveTrackingSensors/EnginOnHalf.svg`
						}
						alt="EngineOn"
					/>
				</div>
				<div>
					<img
						src={
							!ignition
								? `${process.env.PUBLIC_URL}/assets/New/LiveTrackingSensors/EngineOffFull.svg`
								: `${process.env.PUBLIC_URL}/assets/New/LiveTrackingSensors/EngineOffHalf.svg`
						}
						alt="EngineOff"
					/>
				</div>
			</div>
		</>
	);
}
